import OapAccountNavigation from './code/Scripts/components/OapAccountNavigation/OapAccountNavigation.vue';

export default {
  components: {
    OapAccountNavigation,
  },
};
